import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UserIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UserGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.22103 10.2057C9.22103 11.7383 10.4674 12.9846 12 12.9846C13.5326 12.9846 14.779 11.7383 14.779 10.2057C14.779 8.67305 13.5326 7.42669 12 7.42669C10.4674 7.42669 9.22103 8.67305 9.22103 10.2057ZM10.3266 10.2057C10.3266 9.28319 11.0775 8.53223 12 8.53223C12.9225 8.53223 13.6734 9.28319 13.6734 10.2057C13.6734 11.1281 12.9225 11.8791 12 11.8791C11.0775 11.8791 10.3266 11.1281 10.3266 10.2057ZM13.853 8.35206C14.3276 8.82681 14.6215 9.48221 14.6215 10.2051C14.6215 11.651 13.4454 12.8272 11.9994 12.8272C11.2766 12.8272 10.6212 12.5333 10.1464 12.0587C10.6212 12.5336 11.2769 12.8278 12 12.8278C13.446 12.8278 14.6221 11.6517 14.6221 10.2057C14.6221 9.48252 14.328 8.82686 13.853 8.35206ZM12 8.37536C10.9909 8.37536 10.1697 9.19656 10.1697 10.2057C10.1697 10.71 10.3749 11.1675 10.7061 11.4989C10.3745 11.1674 10.1691 10.7097 10.1691 10.205C10.1691 9.19595 10.9903 8.37475 11.9994 8.37475C12.5041 8.37475 12.9618 8.58018 13.2933 8.9118C12.9618 8.58054 12.5044 8.37536 12 8.37536Z"
        fill="#696969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12C4 16.4115 7.58855 20 12 20C16.4115 20 20 16.4114 20 12C20 7.58855 16.4115 4 12 4C7.58855 4 4 7.58855 4 12ZM12 19.8431C13.5257 19.8431 14.951 19.4053 16.1569 18.6486C16.1744 18.6376 16.1918 18.6266 16.2092 18.6155C16.3924 18.4985 16.5705 18.3742 16.7429 18.2428C18.6258 16.8089 19.8431 14.544 19.8431 12C19.8431 9.83532 18.9617 7.87269 17.5389 6.45216C18.9614 7.87264 19.8425 9.83502 19.8425 11.9994C19.8425 16.3242 16.3242 19.8425 11.9994 19.8425C9.87333 19.8425 7.94216 18.9923 6.52808 17.6139C6.75788 17.838 7.00134 18.0481 7.25708 18.2428C7.42954 18.3742 7.60758 18.4985 7.79079 18.6155C7.80817 18.6266 7.82561 18.6377 7.84309 18.6486C9.04898 19.4053 10.4743 19.8431 12 19.8431ZM15.0135 15.7374C14.5178 15.2402 13.8326 14.9322 13.0768 14.9322H10.9232C9.41423 14.9322 8.18669 16.1601 8.18669 17.6691V17.9286C8.18649 17.9285 8.1869 17.9288 8.18669 17.9286L8.18608 17.6685C8.18608 16.1595 9.41362 14.9316 10.9226 14.9316H13.0762C13.8323 14.9316 14.5177 15.2399 15.0135 15.7374ZM12 18.8945C10.6579 18.8945 9.40413 18.5089 8.34355 17.8428V17.6691C8.34355 16.2467 9.5009 15.0891 10.9232 15.0891H13.0768C14.4991 15.0891 15.6565 16.2467 15.6565 17.6691V17.8427C14.5959 18.5089 13.3421 18.8945 12 18.8945ZM15.5735 15.178C16.1393 15.7455 16.5136 16.5041 16.59 17.3475C16.5899 17.3476 16.5902 17.3473 16.59 17.3475C16.5843 17.2844 16.5774 17.2214 16.5684 17.1593C16.4568 16.3914 16.0971 15.7029 15.5735 15.178ZM16.9796 7.01232C15.7031 5.73786 13.9419 4.94868 12 4.94868C8.11207 4.94868 4.94868 8.11207 4.94868 12C4.94868 13.9142 5.71549 15.6528 6.95805 16.9246C5.71513 15.6527 4.94806 13.9139 4.94806 11.9994C4.94806 8.11146 8.11146 4.94806 11.9994 4.94806C13.9416 4.94806 15.703 5.7375 16.9796 7.01232ZM10.9232 13.9835C9.10794 13.9835 7.59513 15.3026 7.29294 17.033C5.9476 15.7739 5.10554 13.9834 5.10554 12C5.10554 8.1987 8.1987 5.10554 12 5.10554C15.8013 5.10554 18.8945 8.19871 18.8945 12C18.8945 13.9834 18.0524 15.7739 16.7071 17.033C16.4049 15.3026 14.8921 13.9835 13.0768 13.9835H10.9232Z"
        fill="#696969"
      />
    </svg>
  );
};

export default UserIcon;
